import { authFetch } from './http/fetchClient';
import { APIUrl } from 'Utils/Utils';
import { ReportField, ReportSchema, ReportTypeSummary } from '../../components/Chat/types';

// The backend's response model sends every optional field key, unset ones as
// null. The form treats "absent" as "not set" (`!== undefined`, `??`), so
// drop the nulls here once instead of null-checking every key downstream.
const stripNullKeys = (field: ReportField): ReportField =>
  Object.fromEntries(Object.entries(field).filter(([, v]) => v !== null)) as unknown as ReportField;

export const reportsApi = {
  getReportTypes: async (): Promise<ReportTypeSummary[]> => {
    const res = await authFetch(`${APIUrl()}/reports/report_types`);
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    const data = await res.json();
    return Array.isArray(data?.report_types) ? data.report_types : [];
  },

  getReportSchema: async (reportId: number): Promise<ReportSchema> => {
    const res = await authFetch(`${APIUrl()}/reports/report_types/${reportId}/schema`);
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    const data: ReportSchema = await res.json();
    return { ...data, fields: (data.fields ?? []).map(stripNullKeys) };
  },
};
